import { useContext } from 'react';
import { DrawerContext } from '../context/DrawerProvider';

const useDrawer = () => {
  const {
    drawerWidth,
    toggleDrawer,
    showDrawer,
    openDrawer,
    closeDrawer,
    showComponent,
  } = useContext(DrawerContext);
  return {
    drawerWidth,
    toggleDrawer,
    showDrawer,
    openDrawer,
    closeDrawer,
    showComponent,
  };
};

export default useDrawer;
